import { initStore } from '../../../common';
import { actions } from './actions';

export const freeSpinsStore = (): void => {
	const initialState = {
		slice: 'FREE_SPINS',
		campaigns: [],
		campaignsLoading: false,
		pagesTotal: 1,
		currentPage: 1,
		partners: [],
		providers: [],
		statuses: [],
		rows: [],
		currencies: [],
		activeCurrency: [],
		columns: [
			'ID',
			'Name',
			'Description',
			'Partner',
			'Status',
			'From - Until',
			'Freespin Total Value',
			'Freespin Bet Value',
			'Freespin Currency',
			'Freespin Expiry',
			'All Games',
			'All Users',
			'Auto Award On Lunch',
			'Device',
			'Allow Api Award',
		],
		activePartners: [],
		filtering: false,
		filters: [{ name: 'searchType', value: 'id' }],
		globalErrors: [],
		globalSuccess: '',
		games: [],
		campaignForm: {
			status: [],
			activePartners: [],
			partners: [],
			from_date: '',
			to_date: '',
			games: [],
			custom_fields: [],
			free_spin_total_value: '',
			free_spin_bet_value: '',
			free_spin_currency: [],
			from_spin_expiry: '',
			all_games: false,
			all_users: false,
			thirdparty_campaign_id: '',
			device: [],
			provider_id: [],
			allow_api_award: false,
			auto_award_on_launch: false,
			formErrors: {},
			globalSuccess: '',
		},
	};

	initStore(actions, initialState);
};
